import { ISO_MAPPING, DEFAULT_POST_CODE_LENGTH } from '@/helpers/consts';
function getAddressAsString(data) {
    let { address } = data;
    const { zip_code, zip_code_postfix, country } = data;
    if (address.includes(zip_code) && country) {
        address = address.replace(zip_code, '').trim();
    }
    if (address.includes(country)) {
        address = address.replace(country, '').trim();
    }
    const formattedZipCode = zip_code + (zip_code_postfix || '');
    address = address.split(',').map(item => item.split(/\s+/).join(' ').trim()).filter(Boolean).join(', ');
    if (formattedZipCode && country) {
        address = `${address}, ${formattedZipCode}`;
    }
    if (country) {
        address = `${address}, ${country}`;
    }
    return address.trim();
}
function parseAddress(addressToParse, country_iso) {
    const zipLength = ISO_MAPPING.find(m => m.iso === country_iso)?.post_code_length || DEFAULT_POST_CODE_LENGTH;
    const regex = new RegExp(`\\b\\d{${zipLength}}\\b`);
    let zipCodeData = addressToParse.match(regex);
    if (!zipCodeData && addressToParse.includes(',')) {
        const parts = addressToParse.split(',').map(p => p.trim());
        for (let i = 1; i < parts.length - 1; i++) {
            const fallback = parts[i].match(/\b\d+\b/);
            if (fallback) {
                zipCodeData = fallback;
                break;
            }
        }
    }
    if (!zipCodeData) {
        throw new Error(`No zip code found in the provided string. ${addressToParse}`);
    }
    const zip_code = zipCodeData[0];
    if (addressToParse.includes(',')) {
        // If the string has commas, split it by commas.
        const data = addressToParse.split(',').map(part => part.trim());
        const address = data[0];
        const country = data[data.length - 1];
        const zipBoundaryRegex = new RegExp(`\\b${zip_code}\\b`);
        const zipSegmentIndex = data.findIndex((part, i) => i > 0 && i < data.length - 1 && zipBoundaryRegex.test(part));
        let zip_code_postfix;
        if (zipSegmentIndex !== -1) {
            if (data[zipSegmentIndex] === zip_code) {
                // zip is standalone — city name is in the previous segment
                zip_code_postfix = zipSegmentIndex > 1 ? data[zipSegmentIndex - 1] : undefined;
            }
            else {
                zip_code_postfix = data[zipSegmentIndex].replace(zip_code, '').trim() || undefined;
            }
        }
        return {
            address,
            zip_code,
            zip_code_postfix,
            country,
        };
    }
    const data = addressToParse.split(zip_code).map(part => part.trim());
    const address = data[0];
    const country = data[1];
    return {
        address,
        zip_code,
        country,
    };
}
function addPostCodeToAddress(calizyAddress, post_code, country) {
    return getAddressAsString({
        address: calizyAddress,
        country,
        zip_code: post_code,
    });
}
export { getAddressAsString, parseAddress, addPostCodeToAddress, };
